import { render, staticRenderFns } from "./ModalGardenhotels.vue?vue&type=template&id=292fde46&scoped=true&"
import script from "./ModalGardenhotels.vue?vue&type=script&lang=ts&"
export * from "./ModalGardenhotels.vue?vue&type=script&lang=ts&"
import style0 from "./ModalGardenhotels.vue?vue&type=style&index=0&id=292fde46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292fde46",
  null
  
)

export default component.exports